import styled from 'styled-components'
import { EuiPanel } from '@equipmentshare/ds2'

export const FullHeightPanel = styled( EuiPanel )`
	height: 100%;
`

export const FlexCenterContainer = styled.div<{ gap?: string }>`
	display: flex;
	align-items: center;
	gap: ${( props ) => props.gap ?? '4px'};
`

export const TruncatedLink = styled.a`
	flex-shrink: 1;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
`
